import React, { useContext, useEffect, useState } from 'react';

import axios from '../../api/axios';
import AuthContext from '../../api/AuthProvider';
import SidebarLeft from '../components/SidebarLeft/SidebarLeft';
import Header from '../components/Header';
import SidebarRight from '../components/SidebarRight/SidebarRight';
import FeedCreate from '../components/Feed/FeedCreate';
import FeedPost from '../components/Feed/FeedPost';

const Feed = () => {
    const { user } = useContext(AuthContext);
    const [posts, setPosts] = useState([]);
    const [followers, setFollowers] = useState([]);
    const [usersFollowed, setUsersFollowed] = useState([]);

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                const response = await axios.get('/api/social/');
                setPosts(response.data.map((feedPost) => feedPost));
            } catch (err) {
                if (err.response) {
                    // not in 200 response range
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                } else {
                    console.log('Error: ' + err.message);
                }
            }
        };
        fetchPosts();

        async function getFollowers() {
            const response = await axios
                .get(`/api/profile/${user.user_id}/followers`)
                .catch((error) => {
                    console.error(error);
                });

            setFollowers(response.data);
        }
        async function getUsersFollowed() {
            const response = await axios
                .get(`/api/profile/${user.user_id}/users-followed`)
                .catch((error) => {
                    console.error(error);
                });

            setUsersFollowed(response.data);
        }
        getFollowers();
        getUsersFollowed();
    }, []);

    return (
        <div className="page-feeds">
            <div className="subpage-feeds">
                <div className="section-sidebar-left">
                    <SidebarLeft
                        followers={followers}
                        usersFollowed={usersFollowed}
                    />
                </div>
                <div className="section-center">
                    <div className="header-feeds">
                        <Header />
                    </div>
                    <div className="feeds-body">
                        <div className="section-feed-create">
                            <FeedCreate />
                        </div>
                        <div className="section-feed-type">
                            <p className="section-feed-type-font">Posts</p>
                            <p className="section-feed-type-font">|</p>
                            <p className="section-feed-type-font">News</p>
                        </div>
                        {posts.map((post) => (
                            <div
                                className="section-feed-post"
                                key={post.created}
                            >
                                <FeedPost postContent={post} />
                            </div>
                        ))}
                    </div>
                </div>
                <div className="section-sidebar-right">
                    <SidebarRight />
                </div>
            </div>
        </div>
    );
};

export default Feed;
